module.exports = __webpack_public_path__ + "img/review.5009cc16.svg";